/**
 * defa.controllers.BaseController
 * Main controller for any random or external simplify resource.
 * @version 1.2.1
 */
import { defa }  from 'defa-object';
import CheatView from 'scripts/defa/application/view-cheat-view';

const channelLayout = Bb.Radio.channel( 'layout' ),
	channelNav    = Bb.Radio.channel( 'nav' ),
	channelUser   = Bb.Radio.channel( 'user' );

const apiHost = defa.vars.apiHost;
const api     = {
	tsSearch: apiHost + '/ts/search',
	validateUrl: apiHost + '/validate?token='
};

const BaseController = Mn.Object.extend( {
	
	// ------------------------------------------------
	// Routes
	// ------------------------------------------------
	
	// - external routes
	
	/**
	 * Opens ACP-users to the ACP-portal
	 * @void
	 */
	showACPortal: function () {
		
		channelNav.trigger( 'app:root', false, { replace: true, } );
		channelNav.trigger( 'external:acp', [defa.vars.legacyUrl ], { replace: false} );
	},
	
	/**
	 * Opens TSP-users to the TSP-portal
	 * @void
	 */
	showTSPortal: function () {
		
		channelNav.trigger( 'app:root', false, { replace: true, } );
		channelNav.trigger( 'external:tsp', [defa.vars.legacyUrl ], { replace: false } );
	},
	
	/**
	 * Opens DTP-users to the DTP-portal
	 * @void
	 */
	showDTPortal: function () {
		
		channelNav.trigger( 'app:root', false, { replace: true, } );
		channelNav.trigger( 'external:dtp', [defa.vars.legacyUrl ], { replace: false } );
	},
	
	/**
	 * Opens automotives download page.
	 * @void
	 */
	showDownloads: function () {
		
		let pID = false;
		
		switch ( this.getLang() ) {
			
			case 'en' :
			case 'fr-ca' :
				pID = 24544;
				break;
			
			case 'no' :
				pID = 27481;
				break;
			
			case 'se' :
				pID = 27336;
				break;
			
			case 'fi' :
				pID = 27685;
				break;
			
		}
		
		channelNav.trigger( 'app:root', false, { replace: true, } );
		
		if ( !pID ) {
			window.open( 'http://old.defa.com/da/corporate/contact_and_support/automotive/downloads/' );
		} else {
			channelNav.trigger( 'external:downloads', [defa.vars.legacyUrl, pID ], { replace: false } );
		}
	},
	
	/**
	 * Opens homes manuals page.
	 * @void
	 */
	showManuals: function () {
		
		channelNav.trigger( 'app:root', false, { replace: true, } );
		channelNav.trigger( 'external:manuals', [defa.vars.legacyUrl ], { replace: false } );
	},
	
	
	// - internal routes
	
	showHome: function () {
		let user = channelUser.request( 'model' );
		
		$( '.progress' ).remove();
		
		// if the user is logged in, just go to devices.
		if ( channelUser.request( 'is:logged:in' ) || channelUser.request( 'has:bluetooth' ) ) {
			channelNav.trigger( 'unit:list', false, { trigger: true, replace: true, } );
			
			// if user isn't logged in, decide what elements to show.
		} else {
			
			// if toyota, show the bluetooth scan button.
			if ( channelLayout.request( 'is:toyota' ) ) {
				$( '.opening-bluetooth' ).removeAttr( 'hidden' );
				
				// then show the entire block
				$( '.opening-view' ).removeAttr( 'hidden' );
				
				// if nothing special, go to the user:logincreate.
			} else {
				channelNav.trigger( 'user:logincreate', false, { trigger: true, replace: true } );
			}
		}
	},
	
	validateEmail: function(validationCode, query){
		console.group("validateEmail");
		let queryArray = query && query !== null && query.length > 0 ? query.split('&') : null;
		let email = this._getEmailFromQuery(queryArray);
		let referrer = this._getRefFromQuery(queryArray);
		let unitToken = this._getUnitTokeFromQuery(queryArray);
		
		if(validationCode && validationCode != null && validationCode.length > 0){
			
			$.get(api.validateUrl + validationCode)
			 .done( function ( response ) {
				 console.log("validation completed succesfully with response: " + JSON.stringify(response));
				 console.log("validation succesfull with message: " + response.message)
			 } )
			 .fail( function ( response ) {
				 console.log("validation failed with response: " + JSON.stringify(response));
				 console.log("validation failed with message: " + response && response != null && response.responseJSON && response.responseJSON != null ? response.responseJSON.message : "No message in response");
			 });
		}
		console.groupEnd();
		this._goToValidateReferrer(referrer, email, unitToken);
	},
	
	_goToValidateReferrer: function(referrer, email, unitToken){
		let route = referrer && referrer !== null && referrer.length > 0 ? referrer : '/accounts/login';
		if(route && route !== null && route.length > 0) {
			route = route.lastIndexOf( '/' ) === route.length - 1 ? route.substring( 0, route.length - 1 ) : route;
			if ( email && email.length > 0 ) {
				if ( route.indexOf( 'create' ) === -1 && route.indexOf( 'login' ) === -1 ) {
					route += '/login'
				}
				route += route.lastIndexOf('/') === route.length - 1 ? email : '/' + email;
			}
			if ( unitToken && unitToken.length > 0 ) {
				route += route.lastIndexOf('/') === route.length - 1 ? unitToken : '/' + unitToken;
			}
		}
		route = encodeURI(route);
		Bb.history.navigate(route, { trigger: true, });
	},
	
	_getEmailFromQuery: function(queryArray){
		return this._getParamvalueFromQuery(queryArray, 'email');
	},
	
	_getRefFromQuery: function(queryArray){
		return this._getParamvalueFromQuery(queryArray, 'ref');
	},
	
	_getUnitTokeFromQuery: function(queryArray){
		return this._getParamvalueFromQuery(queryArray, 'token')
		
	},
	
	_getParamvalueFromQuery(queryArray, keyLookup){
		let paramValue = null;
		if(queryArray !== null && queryArray.length > 0){
			for ( let i = 0; i < queryArray.length; i++ ) {
				if(queryArray[i].indexOf(keyLookup) >= 0){
					let valueParamArray = queryArray[i].split('=');
					paramValue = valueParamArray .length  === 2 ? valueParamArray [1] : null;
				}
			}
		}
		return paramValue;
	},
	/**
	 * Triggers when a "404 - not found" url, is entered into the application.
	 * @void
	 */
	showFallback: function () {
		
		channelNav.trigger( 'app:root', false, { trigger: true, replace: true, } );
	},
	
	/**
	 * Admin cheat menu, kinda works...
	 * @void
	 */
	konami: function () {
		
		if ( !channelUser.request( 'model' ).hasRoles( [ 'ADMINISTRATOR', ] ) ) {
			channelNav.trigger( 'app:root', false, { trigger: true, replace: true, } );
		} else {
			
			let cheatView = new CheatView();
			channelLayout.request( 'root' ).showChildView( 'main', cheatView );
		}
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Gets the current html-language, while defaulting to available languages on defa.com.
	 * @return {string}  The language variable for defa.com urls.
	 */
	getLang: function () {
		
		let lang = defa.objects.languageSettings.country;
		
		if ( 'fr' === lang ) {
			lang = 'fr-ca';
		}
		
		if ( 'nb' === lang ) {
			lang = 'no';
		}
		
		return lang;
		
	},
	
	
} );

export default BaseController;
